import { getOrderApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ApproveOrderExecutorRequest, ScheduleOrderRequest } from '@/core/generated/api';

/** Выполняет действия администратора с исполнителем заказа */
export const orderCommentActionService = {
    /** Утверждает исполнителя заказа */
    async approveExecutor(request: ApproveOrderExecutorRequest): Promise<void> {
        try {
            await getOrderApi()
                .apiV1OrdersApproveOrderExecutorByAdminPost({
                    approveOrderExecutorRequest: request,
                });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Запускает поиск исполнителя по заказу */
    async startExecutorSearch(request: ScheduleOrderRequest): Promise<void> {
        try {
            await getOrderApi().scheduleOrderByAdmin({ scheduleOrderRequest: request });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
